import * as z from "zod/v4/mini";

export const sentryEnvConfigSchema = z.object({
    enable: z.optional(z.boolean()),
    dsn: z.optional(z.url()),
    enableMetrics: z.optional(z.boolean()),
    sendDefaultPii: z.optional(z.boolean()),
    tracesSampleRate: z.optional(z.number().check(z.minimum(0), z.maximum(1))),
    levels: z._default(z.array(z.string()), ["error"]),
}).check((ctx) => {
    if (ctx.value.enable !== false && !ctx.value.dsn) {
        ctx.issues.push({
            code: "custom",
            message: "dsn is required when sentry is enabled",
            path: ["dsn"],
            input: ctx.value,
        });
    }
});

export const aliceIqEnvConfigSchema = z.object({
    enable: z.optional(z.boolean()),
    version: z.optional(z.number()),
    url: z.optional(z.url()),
}).check((ctx) => {
    if (ctx.value.enable !== false && !ctx.value.url) {
        ctx.issues.push({
            code: "custom",
            message: "url is required when aliceIQ is enabled",
            path: ["url"],
            input: ctx.value,
        });
    }
});

export const envConfigSchema = z.object({
    env: z.optional(z.string()),
    sentry: z.optional(sentryEnvConfigSchema),
    aliceIQ: z.optional(aliceIqEnvConfigSchema),
});

export type TypeSentryEnvConfig = z.infer<typeof sentryEnvConfigSchema>;
export type TypeAliceIqEnvConfig = z.infer<typeof aliceIqEnvConfigSchema>;
export type TypeEnvConfig = z.infer<typeof envConfigSchema>;
